import * as React from "react";
interface props {
  className?: string;
  width?: string;
  height?: string;
}

const ImageUploadSVG = ({ className, width, height }: props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : "134"}
    height={height ? height : "84"}
    className={className}
    fill="none"
    viewBox="0 0 134 128"
  >
    <g filter="url(#filter0_d_750_19518)">
      <path fill="#fff" d="M22 18h90v84H22z"></path>
      <path fill="#F9F7FF" d="M26 22h82v62H26z"></path>
      <path
        fill="#E3D5FE"
        d="M91.168 30.586c-.283 0-.55.067-.788.184-.188-1.561-1.495-2.77-3.08-2.77a3.08 3.08 0 0 0-2.546 1.353 1.1 1.1 0 0 0-.73-.28c-.615 0-1.113.507-1.113 1.133q.002.205.068.388a2 2 0 0 0-.147-.008c-1.012 0-1.832.835-1.832 1.865s.82 1.865 1.832 1.865h8.336c1.012 0 1.832-.835 1.832-1.865s-.82-1.865-1.832-1.865"
      ></path>
      <path
        fill="url(#paint0_linear_750_19518)"
        d="M63.891 46.285h4.692v37.333h-4.692z"
      ></path>
      <path
        fill="url(#paint1_linear_750_19518)"
        d="M67.141 42.25h4.692v4.035h-4.692z"
      ></path>
      <path
        fill="url(#paint2_linear_750_19518)"
        d="M69.797 38.996h4.692v3.254h-4.692z"
      ></path>
      <path
        fill="#F4EEFF"
        fillRule="evenodd"
        d="M78.693 38.996H74.5v3.25h-2.664v4.035h9.455v-4.035h-2.598zm-10.107 7.29h16.111v37.332H68.586z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#8355EC"
        d="M77.594 49.871h.939V83.54h-.939zM75.445 49.871h-.939v33.67h.94z"
      ></path>
      <path
        fill="#BE8ABE"
        d="M80.695 49.871h.939V83.54h-.939zM72.344 49.871h-.94v33.67h.94z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M56.954 54.746h-3.04v2.108h3.04zm-4.767 2.11h3.04v2.609h.007v-2.61h6.126v2.61h2.21V83.65H53.133V59.47h-.015v24.18h-3.04V59.465h2.11zm7.49-2.11H56.96v2.108h2.716z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#C1AAF6"
        d="M53.141 59.75h10.437v24.089H53.141z"
        opacity="0.48"
      ></path>
      <path
        fill="url(#paint3_linear_750_19518)"
        d="M50.078 59.75h3.04v24.089h-3.04z"
        opacity="0.45"
      ></path>
      <path
        fill="url(#paint4_linear_750_19518)"
        d="M52.188 57.137h3.04v2.518h-3.04z"
        opacity="0.45"
      ></path>
      <path
        fill="url(#paint5_linear_750_19518)"
        d="M53.906 55.027h3.04v2.013h-3.04z"
        opacity="0.45"
      ></path>
      <path
        fill="#8355EC"
        d="M58.961 62.07h.608v21.716h-.608zM57.563 62.07h-.608v21.716h.608z"
        opacity="0.77"
      ></path>
      <path
        fill="#BE8ABE"
        d="M60.969 62.07h.608v21.716h-.608zM55.555 62.07h-.608v21.716h.608z"
        opacity="0.77"
      ></path>
      <path
        fill="#C1AAF6"
        d="M55.25 57.137h6.125v2.518H55.25zM56.969 55.027h2.716v2.013h-2.716z"
        opacity="0.48"
      ></path>
      <path
        fill="#E3D5FE"
        d="M50.931 46.509c-.165 0-.32.039-.46.106-.11-.91-.871-1.615-1.796-1.615a1.8 1.8 0 0 0-1.485.79.64.64 0 0 0-.426-.164.655.655 0 0 0-.61.887l-.085-.004c-.59 0-1.069.487-1.069 1.087 0 .601.479 1.088 1.069 1.088h4.862c.59 0 1.069-.487 1.069-1.087 0-.601-.478-1.088-1.069-1.088"
      ></path>
      <path
        fill="#B996FF"
        d="M41.895 97h-1.44l-3.497-5.698h-.044q.02.288.034.61.02.322.03.664.014.343.024.694V97h-1.065v-7.139h1.431l3.491 5.66h.035l-.025-.572-.03-.664a53 53 0 0 1-.014-.669v-3.755h1.07zm9.612-3.58q0 .826-.21 1.505-.204.673-.62 1.162a2.76 2.76 0 0 1-1.04.747q-.625.264-1.465.264-.855 0-1.484-.264a2.74 2.74 0 0 1-1.04-.752 3.25 3.25 0 0 1-.615-1.167 5.2 5.2 0 0 1-.205-1.504q0-1.104.361-1.924.367-.825 1.108-1.279.748-.459 1.885-.459 1.114 0 1.85.454.738.455 1.104 1.28.372.819.371 1.938m-5.449 0q0 .826.225 1.432.225.6.688.927.469.323 1.202.323.736 0 1.2-.323.465-.327.684-.927.22-.606.22-1.431 0-1.255-.503-1.963-.498-.713-1.592-.713-.732 0-1.206.322-.468.323-.693.923-.225.596-.225 1.43m14.456-3.559q1.38 0 2.016.567.635.565.635 1.587 0 .463-.147.883-.141.416-.468.738-.327.317-.865.503-.532.185-1.313.185h-.762V97h-1.172v-7.139zm-.079.972h-.825v2.515h.64q.552 0 .937-.127.387-.132.586-.415.2-.284.2-.747 0-.62-.376-.923-.37-.303-1.162-.303M71.621 97h-1.167v-3.223h-3.291V97H65.99v-7.139h1.171v2.92h3.291v-2.92h1.168zm9.627-3.58q0 .826-.21 1.505-.205.673-.62 1.162a2.76 2.76 0 0 1-1.04.747q-.625.264-1.465.264-.854 0-1.484-.264a2.74 2.74 0 0 1-1.04-.752 3.25 3.25 0 0 1-.616-1.167 5.2 5.2 0 0 1-.205-1.504q0-1.104.362-1.924.366-.825 1.108-1.279.747-.459 1.885-.459 1.113 0 1.85.454.738.455 1.104 1.28.37.819.371 1.938m-5.45 0q0 .826.225 1.432.225.6.689.927.469.323 1.201.323.738 0 1.201-.323.464-.327.684-.927.22-.606.22-1.431 0-1.255-.503-1.963-.498-.713-1.592-.713-.732 0-1.206.322-.47.323-.694.923-.225.596-.224 1.43M86.658 97H85.48v-6.143h-2.09v-.996h5.352v.996h-2.085zm10.916-3.58q0 .826-.21 1.505-.204.673-.62 1.162a2.76 2.76 0 0 1-1.04.747q-.624.264-1.465.264-.854 0-1.484-.264a2.74 2.74 0 0 1-1.04-.752 3.25 3.25 0 0 1-.615-1.167 5.2 5.2 0 0 1-.205-1.504q0-1.104.361-1.924.366-.825 1.109-1.279.747-.459 1.884-.459 1.114 0 1.85.454.738.455 1.104 1.28.372.819.371 1.938m-5.449 0q0 .826.225 1.432.225.6.688.927.47.323 1.201.323.738 0 1.202-.323.464-.327.683-.927.22-.606.22-1.431 0-1.255-.503-1.963-.498-.713-1.592-.713-.732 0-1.206.322-.468.323-.693.923-.225.596-.225 1.43"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_750_19518"
        x1="66.237"
        x2="66.237"
        y1="46.285"
        y2="83.618"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1EAFF"></stop>
        <stop offset="1" stopColor="#C1BBCC"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_750_19518"
        x1="69.487"
        x2="69.487"
        y1="42.25"
        y2="46.285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1BBCC"></stop>
        <stop offset="1" stopColor="#F1EAFF"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_750_19518"
        x1="72.143"
        x2="72.143"
        y1="38.996"
        y2="42.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1BBCC"></stop>
        <stop offset="1" stopColor="#F1EAFF"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_750_19518"
        x1="51.598"
        x2="51.598"
        y1="59.75"
        y2="83.839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1AAF6"></stop>
        <stop offset="1" stopColor="#371083"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_750_19518"
        x1="53.707"
        x2="53.707"
        y1="57.137"
        y2="59.655"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1AAF6"></stop>
        <stop offset="1" stopColor="#371083"></stop>
      </linearGradient>
      <linearGradient
        id="paint5_linear_750_19518"
        x1="55.426"
        x2="55.426"
        y1="55.027"
        y2="57.04"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C1AAF6"></stop>
        <stop offset="1" stopColor="#371083"></stop>
      </linearGradient>
      <filter
        id="filter0_d_750_19518"
        width="134"
        height="128"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="4"></feOffset>
        <feGaussianBlur stdDeviation="11"></feGaussianBlur>
        <feComposite in2="hardAlpha" operator="out"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"></feColorMatrix>
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_750_19518"
        ></feBlend>
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_750_19518"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
);

export default ImageUploadSVG;
